import React, { useEffect } from 'react';
import { Spinner } from '../../../../common';
import BlocksSortOrder from './BlocksSortOrder.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  useGetBlocksQuery,
  useSaveBlocksOrderMutation,
} from '../../../../../redux/services/blocks';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';

const BlocksOrderPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Úprava poradia blokov') + ' - FRI CMS';
  }, []); // Runs on mount

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { data: blocks, isLoading, refetch } = useGetBlocksQuery();

  const [
    saveBlocksOrder,
    {
      isSuccess: isSaveSuccess,
      isError: isSaveError,
      isLoading: isSaving,
      error: saveError,
    },
  ] = useSaveBlocksOrderMutation();

  useEffect(() => {
    if (!isSaving) {
      if (isSaveSuccess) {
        showSaveSuccess();
        navigate(routes.cmsBlocksOrder);
        refetch();
      } else if (isSaveError) {
        showSaveFailed(saveError);
      }
    }
  }, [isSaveSuccess, isSaveError, isSaving]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Úprava poradia blokov')}
        backUrl={routes.cmsBlocks}
        backUrlTooltip={t('Bloky')}
        permissionsBasic={'blocks'}
      />

      <BlocksSortOrder
        allBlocks={blocks}
        onOrderSave={(items, isEnglish) =>
          saveBlocksOrder({ items, isEnglish })
        }
      />
    </>
  );
};

export default BlocksOrderPage;
